/* eslint-disable import/no-unresolved */
import React, { useEffect, useContext } from 'react';
import { Helmet } from 'react-helmet';
import Banner from './Banner';
import { useBrandDetails } from 'dw-au-react-components';
import { ContentfulContext } from '../../context/Contentful';
import styled from 'styled-components';
import BlogCategories from './Categorys';

const ContentBlockSection = styled.section`
	.content-block-section {
		margin-left: auto;
		margin-right: auto;
		padding-left: 15px;
		padding-right: 15px;
		@media (min-width: 992px) {
			max-width: 970px;
		}
		@media (min-width: 768px) and (max-width: 991px) {
			max-width: 720px;
		}
		@media (min-width: 576px) and (max-width: 768px) {
			max-width: 540px;
		}
		@media (max-width: 767px) {
			max-width: 100%;
		}
	}
	.content-block-title {
		margin-bottom: 1.5rem;
		font-size: 28px;
		font-weight: bold;
	}
	.content-block-section-text {
		font-size: 16px;
	}
`;

const LandingPage = () => {
	const brandDetails = useBrandDetails();
	const { blogLandingData, blogConfigData } = useContext(ContentfulContext);

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const updateMetaDescription = () => {
		const metaDescription = document.querySelector('meta[name="description"]');
		if (metaDescription && blogConfigData?.metaDescription) {
			metaDescription.setAttribute('content', blogConfigData?.metaDescription);
		}
	};

	return (
		<>
			<Helmet onChangeClientState={() => updateMetaDescription()}>
				<title>
					{blogConfigData?.metaTitle} - {brandDetails?.name}
				</title>
				<link rel='canonical' href={`${location?.origin}/blog`}></link>
			</Helmet>
			{blogLandingData.length > 0 ? (
				<>
					<Banner
						brandDetails={brandDetails}
						config={blogConfigData}
						url={'/images/au/common/blog/wpe_bg_banner.png'}
					/>
					<ContentBlockSection>
						<div className='content-block-section'>
							<h1 className='content-block-title mb-5'>
								{blogConfigData?.landingPageTitle ??
									`${brandDetails.name} uncorked: discovering the world of wine`}
							</h1>
							<div>
								<div data-testid='content-block-section-text'>
									{blogConfigData?.landingPageSubtitle ??
										'Whether you’re a seasoned connoisseur or a curious beginner, you’ll find something to inspire and educate you here.'}
								</div>
							</div>
						</div>
					</ContentBlockSection>
					<BlogCategories
						categories={blogConfigData?.blogCategories?.items || []}
					/>
					{/* <TopPosts blogLandingData={topBlogPosts} config={blogConfigData} /> */}
					{/* {brandDetails.tag === 'wpe' && (
						<QuizBanner brandDetails={brandDetails} />
					)} */}
					{/* <LatestPost
						blogLandingData={blogLandingData}
						brandDetails={brandDetails}
					/> */}
					{/* {brandDetails.tag === 'adc' && <Discount />} */}
					{/* <InstagramJourney brandDetails={brandDetails} /> */}
				</>
			) : (
				<div className='container'>
					<div className='alert alert-info m-20'>No blog items found.</div>
				</div>
			)}
		</>
	);
};

export default LandingPage;
